import styled from '@emotion/styled';

export const TeamSelectOptionContainer = styled.div`
  display: flex;
  align-items: center;
  
  .team-select-logo {
    margin-right: 16px;
  }
`;
